import React from 'react';
import CONTENTO_ACCESSIBILITIES from '../../domain/ContentoAccessibilities';
import { CARD_TYPE } from '../ContentItemCarousel/ContentItemCarousel';
import {
    DisplayWindowCarousel,
    DisplayWindowShowCase,
    Hero,
    HiddenHeading,
    StyledDisplayWindow,
} from './DisplayWindow.styles';
import CampaignHero from 'app/ui-components/CampaignHero/CampaignHero';
import env from 'app/env';
import { useRouter } from 'next/router';

const DisplayWindow = ({
    items,
    heroItem = null,
    currentAccessibilityChoiceContento = CONTENTO_ACCESSIBILITIES.DEFAULT,
    onItemClick,
    id,
}) => {
    const router = useRouter();
    if (!items || items.length === 0) {
        return null;
    }

    const forceCampaign = Boolean(router.query.forceCampaign) || false;
    const shouldDisplayCampaign =
        env.DISPLAY_WINDOW_EURO_TITLE_ID === heroItem.item.parent?.id || forceCampaign;

    return (
        <StyledDisplayWindow data-helix-type="list" aria-label="Rekommenderat" className="lp_rec">
            <HiddenHeading>Rekommenderat</HiddenHeading>

            {shouldDisplayCampaign ? (
                <CampaignHero
                    item={heroItem}
                    onAfterClick={onItemClick}
                    currentAccessibilityChoiceContento={currentAccessibilityChoiceContento}
                    wasForced={forceCampaign}
                />
            ) : (
                <Hero
                    item={heroItem}
                    onAfterClick={onItemClick}
                    currentAccessibilityChoiceContento={currentAccessibilityChoiceContento}
                />
            )}
            <DisplayWindowShowCase
                items={[heroItem, ...items]}
                isCampaign={shouldDisplayCampaign}
                currentAccessibilityChoiceContento={currentAccessibilityChoiceContento}
                onItemClick={onItemClick}
                isDisplaywindow
            />
            <DisplayWindowCarousel
                items={items}
                id={id}
                dataRt="display-window-carousel"
                key="display-window-carousel"
                editModeActivated={false}
                isInSweden={true}
                cardType={CARD_TYPE.SHOWCASE}
                currentAccessibilityChoiceContento={currentAccessibilityChoiceContento}
                onItemClick={onItemClick}
                inViewRender={false}
            />
        </StyledDisplayWindow>
    );
};

export default DisplayWindow;
